import styled from 'styled-components';

export const SSearchHistoryContent = styled.div`
  min-width: 440px;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  max-height: 400px;
  padding: 0 2px;
`;

export const SSearchBarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${({ theme }) => theme.color.grey95};
  border-radius: 8px;
  padding: 8px 12px;
  margin: 10px 12px 8px;

  svg {
    width: 16px;
    height: 16px;
    fill: ${({ theme }) => theme.color.grey55};
    flex-shrink: 0;
  }
`;

export const SSearchInput = styled.input`
  border: none;
  outline: none;
  background: transparent;
  flex: 1;
  font-size: 14px;
  color: ${({ theme }) => theme.color.grey15};
  min-width: 0;

  &::placeholder {
    color: ${({ theme }) => theme.color.grey55};
  }
`;

export const SViewAllRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 12px;
  border-top: 1px solid ${({ theme }) => theme.color.grey90};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.color.grey95};
  }

  svg {
    width: 14px;
    height: 14px;
    fill: ${({ theme }) => theme.color.grey15};
  }
`;
